import ProjectSelect from "Dashboard/scenes/Projects/components/ProjectSelect";
import { ICreateOutputItem } from "Dashboard/scenes/Stock/domain/ICreateOutputItem";
import { IStockOutputForProjectOrPartnerCreate } from "Dashboard/scenes/Stock/domain/IStockOutputForProjectOrPartnerCreate";
import { stockService } from "Dashboard/scenes/Stock/services/stock.service";
import { ChangeEvent, useEffect, useState } from "react";
import {
  Control,
  Controller,
  FieldErrorsImpl,
  UseFormGetValues,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormSetValue
} from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FormatDateIso } from "utils/dateUtils";
import { createStockReservation, selectState, setSelectedPartnerId, setSelectedReservationId, updateStockReservation } from "../../Input/inputSlice";
import "../output-dialog.scss";
import DriverSelectCreate from "../../Input/components/DriverSelectCreate";
import VehicleSelectCreate from "../../Input/components/VehicleSelectCreate";
import { useAppDispatch } from "hooks/hooks";
import { resetOutputValue } from "../../Input/inputSlice";
import { styles } from "../../../../../../components/Popover/popoverSelectStyle";
import { useSelector } from "react-redux";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesStock from "Dashboard/scenes/Stock/popover.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IOption } from "Dashboard/domain/IOption";
import DatePicker from "react-datepicker";
import PartnerSelect from "Dashboard/scenes/Partners/components/PartnerSelect ";
import { IoIosSave } from "react-icons/io";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { IStockReservation } from "Dashboard/scenes/Stock/domain/IStockReservation";

interface IProps {
  handleSubmit: UseFormHandleSubmit<IStockOutputForProjectOrPartnerCreate>;
  register: UseFormRegister<IStockOutputForProjectOrPartnerCreate>;
  getValues: UseFormGetValues<IStockOutputForProjectOrPartnerCreate>;
  setValue: UseFormSetValue<IStockOutputForProjectOrPartnerCreate>;
  control: Control<IStockOutputForProjectOrPartnerCreate, any>;
  errors: Partial<FieldErrorsImpl<IStockOutputForProjectOrPartnerCreate>>;
  reset: () => void;
  driverValue: IOption | undefined;
  setDriverValue: React.Dispatch<React.SetStateAction<IOption | undefined>>;
  vehicleValue: IOption | undefined;
  setVehicleValue: React.Dispatch<React.SetStateAction<IOption | undefined>>;
  type: string;
  setType: React.Dispatch<React.SetStateAction<string>>;
  partnerValue: number | undefined;
  setPartnerValue: React.Dispatch<React.SetStateAction<number | undefined>>;
  close: Function;
};

const NewStockOutputToProjectOrPartnerPopover = (props: IProps) => {

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user } = useSelector(selectStateAuth);

  const {
    register,
    handleSubmit,
    control,
    getValues,
    setValue,
    errors,
    reset,
  } = props;

  const [billOfLandingSequence, setBillOfLandingSequence] = useState(0);
  const [requisitionSequence, setRequisitionSequence] = useState(0);
  const [submitButton, setSubmitButton] = useState<"output" | "reservation">("output");

  const resetForm = () => {
    reset();
    props.setPartnerValue(undefined);
    dispatch(setSelectedPartnerId(undefined));
    dispatch(resetOutputValue());
  };

  const closeDialog = () => {
    resetForm();
    props.close();
  };

  const onValueChange = (event: ChangeEvent<HTMLInputElement>) => {
    props.setType(event.target.value);
  };

  const {
    outputValues: { map, repository },
    selectedPartner,
    reservations,
    selectedReservationId,
  } = useSelector(selectState);

  useEffect(() => {
    if (selectedReservationId !== undefined) {
      for (var reservation of reservations) {
        if (reservation.reservationId === selectedReservationId) {
          if (reservation.partner) {
            props.setType("Partner");
            props.setPartnerValue(reservation.partner.partnerId);
            dispatch(setSelectedPartnerId(reservation.partner.partnerId));
            setValue("partnerId", reservation.partner.partnerId);
          } else if (reservation.project) {
            props.setType("Project");
            setValue("projectId", reservation.project.projectId);
            setValue("projectIdOverride", reservation.projectOverride?.projectId);
          }
          setValue("note", reservation.note);
          setValue("date", reservation.date);
          break;
        }
      }
    } else {
      setValue("date", FormatDateIso(new Date()));
    }
  }, [reservations, selectedReservationId]);

  const doOutput = () => {
    setSubmitButton("output");
  }

  const doReservation = () => {
    setSubmitButton("reservation");
  }

  const onSubmit = async (data: IStockOutputForProjectOrPartnerCreate) => {
    const outputItems: ICreateOutputItem[] = [];
    for (const [key, value] of Object.entries(map)) {
      outputItems.push({
        inputId: Number(key),
        quantityAmount: value || 0,
      });
    }

    try {
      if (props.type === "Project") {
        if (submitButton === 'output') {
          await stockService.createOutputProject("Lager", {
            repositoryId: data.repositoryId,
            note: data.note,
            projectId: data.projectId,
            projectIdOverride: data.projectIdOverride,
            date: data.date,
            takenAwayByDriverId: data.takenAwayByDriverId,
            takenAwayByVehicleId: data.takenAwayByVehicleId,
            items: outputItems,
            reservationId: selectedReservationId,
          });
        } else {
          if (selectedReservationId === undefined) {
            await dispatch(createStockReservation({
              repositoryId: data.repositoryId,
              note: data.note,
              projectId: data.projectId,
              projectIdOverride: data.projectIdOverride,
              date: data.date,
              takenAwayByDriverId: data.takenAwayByDriverId,
              takenAwayByVehicleId: data.takenAwayByVehicleId,
              items: outputItems,
            }));
          } else {
            await dispatch(updateStockReservation({
              reservationId: selectedReservationId,
              repositoryId: data.repositoryId,
              note: data.note,
              projectId: data.projectId,
              projectIdOverride: data.projectIdOverride,
              date: data.date,
              takenAwayByDriverId: data.takenAwayByDriverId,
              takenAwayByVehicleId: data.takenAwayByVehicleId,
              items: outputItems,
            }));
          }
        }
      } else {
        if (submitButton === 'output') {
          await stockService.createOutputPartner("Lager", {
            repositoryId: data.repositoryId,
            note: data.note,
            partnerId: data.partnerId,
            date: data.date,
            takenAwayByDriverId: data.takenAwayByDriverId,
            takenAwayByVehicleId: data.takenAwayByVehicleId,
            items: outputItems,
            reservationId: selectedReservationId,
          });
        } else {
          if (selectedReservationId === undefined) {
            await dispatch(createStockReservation({
              repositoryId: data.repositoryId,
              note: data.note,
              partnerId: data.partnerId,
              date: data.date,
              takenAwayByDriverId: data.takenAwayByDriverId,
              takenAwayByVehicleId: data.takenAwayByVehicleId,
              items: outputItems,
            }));
          } else {
            await dispatch(updateStockReservation({
              reservationId: selectedReservationId,
              repositoryId: data.repositoryId,
              note: data.note,
              partnerId: data.partnerId,
              projectIdOverride: data.projectIdOverride,
              date: data.date,
              takenAwayByDriverId: data.takenAwayByDriverId,
              takenAwayByVehicleId: data.takenAwayByVehicleId,
              items: outputItems,
            }));
          }
        }
      }
      dispatch(setSelectedReservationId(undefined));
      if (submitButton === "output") {
        navigate("/stock/output");
        toast.success("Izdavanje je uspešno izvršeno.");
        resetForm();
      } else {
        toast.success("Rezervacija je uspešno izvršena.");
        closeDialog();
      }
    } catch (err: any) {
      if (err.response.status === 407) {
        toast.error("Izdavanje nije izvršeno jer neki uneseni podaci nisu ispravni");
      } else if (err.response.status === 403) {
        toast.error("Nije dozvoljeno izdavanje lagera (da li ste zaposleni u firmi?)");
      }
    }
  };

  useEffect(() => {
    async function getData() {
      if (repository) {
        const rep = await stockService.getRepositoryForStock(
          "Lager",
          repository.repositoryId
        );
        setBillOfLandingSequence(rep.billOfLandingSequence);
        setRequisitionSequence(rep.requisitionSequence);
      }
    }
    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, [repository]);

  return (
    <form
      className={`
        ${classesStock.newStockOutputPopover} ${classes.basicPopover}`}
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>magacin</label>
          <div>
            <input type="text" className={classes.subInput}
              value={repository?.name} disabled />
          </div>
          <input type="hidden" className={classes.dotField}
            value={repository?.repositoryId}
            {...register("repositoryId", { valueAsNumber: true })}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>sledeći br otpremnice</label>
          <div>
            <input type="text" className={classes.subInput}
              value={billOfLandingSequence} disabled />
          </div>
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>sledeći br trebovanja</label>
          <div>
            <input type="text" className={classes.subInput}
              value={requisitionSequence} disabled />
          </div>
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}
              ${classesStock.paragraph}`}>
          <label className={classes.mr5}>izdajem za</label>
          <div className={classesStock.radioButtonsDiv}>
            <input
              type="radio"
              value="Project"
              checked={props.type === "Project"}
              onChange={onValueChange}
              name="type"
            />
            <label>projekat</label>
            <input
              type="radio"
              value="Partner"
              checked={props.type === "Partner"}
              onChange={onValueChange}
              name="type"
            />
            <label>saradniku</label>
          </div>
        </div>
      </div>
      {props.type === "Project" && (
        <>
          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}
                  ${errors.projectId ? classes.itemError : ""}`}>
              <label className={classes.mr5}>izdajem za projekat</label>
              <Controller
                name="projectId"
                control={control}
                defaultValue={undefined}
                rules={{
                  required: true,
                }}
                render={({ field: { onChange } }) => (
                  <ProjectSelect
                    value={getValues("projectId")}
                    customStyles={styles.customStyleClassic}
                    error={errors.projectId}
                    onChange={onChange}
                  />
                )}
              />
            </div>
          </div>

          <div className={`${classes.row} ${classesStock.paragraph}`}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>
                ime na otpremnici<br />i trebovanju
              </label>
              <Controller
                name="projectIdOverride"
                control={control}
                defaultValue={undefined}
                render={({ field: { onChange } }) => (
                  <ProjectSelect
                    value={getValues("projectIdOverride")}
                    customStyles={styles.customStyleClassic}
                    onChange={onChange}
                  />
                )}
              />
            </div>
          </div>
        </>
      )}
      {props.type === "Partner" && (
        <>
          <div className={classes.row} >
            <div className={`${classes.col} ${classes.rowDir}
                  ${errors.partnerId ? classes.itemError : ""}`}>
              <label className={classes.mr5}>*izdajem saradniku</label>
              <Controller
                name="partnerId"
                control={control}
                defaultValue={undefined}
                render={({ field: { onChange } }) => (
                  <PartnerSelect
                    value={props.partnerValue}
                    setValue={props.setPartnerValue}
                    customStyles={styles.customStyleClassic}
                    error={errors.partnerId}
                    onChange={onChange}
                  />
                )}
              />
            </div>
          </div>

          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>mesto</label>
              <div>
                <input
                  type="text" className={classes.subInput}
                  value={selectedPartner?.municipality?.name ?? ""}
                  disabled
                />
              </div>
            </div>
          </div>

          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>adresa</label>
              <div>
                <input type="text" className={classes.subInput}
                  value={selectedPartner?.address ?? ""}
                  disabled
                />
              </div>
            </div>
          </div>

          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>pib</label>
              <div>
                <input type="text" className={classes.subInput}
                  value={selectedPartner?.id ?? ""} disabled
                />
              </div>
            </div>
          </div>
          <div className={classesStock.paragraph}></div>
        </>
      )}

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>odvezao</label>
          <Controller
            name="takenAwayByDriverId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: false,
            }}
            render={({ field: { onChange } }) => (
              <DriverSelectCreate
                value={props.driverValue}
                setValue={props.setDriverValue}
                error={errors.takenAwayByDriverId}
                customStyles={styles.customStyleClassic}
                onChange={onChange}
                preserveInput={true}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>registracija</label>
          <Controller
            name="takenAwayByVehicleId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: false,
            }}
            render={({ field: { onChange } }) => (
              <VehicleSelectCreate
                vehicleValue={props.vehicleValue}
                setVehicleValue={props.setVehicleValue}
                customStyles={styles.customStyleClassic}
                error={errors.takenAwayByVehicleId}
                onChange={onChange}
                preserveInput={true}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>napomena</label>
          <textarea {...register("note")} />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>datum</label>
          <div>
            <Controller
              control={control}
              name="date"
              defaultValue={undefined}
              rules={{ required: false }}
              render={({ field: { onChange, value } }) => (
                <DatePicker
                  onChange={(date) =>
                    onChange(date ? FormatDateIso(date) : undefined)
                  }
                  showMonthDropdown
                  showYearDropdown
                  dateFormat="dd.MM.yyyy"
                  selected={value ? new Date(value) : null}
                  className={`${classes.itemBorder} ${classes.dateItem}
                      ${errors.date ? classes.itemError : ""}`}
                />
              )}
            />
          </div>
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.buttons}`}>
          {props.type === "Partner" && (
            <div>
              <div>
                <b>* ako su polja sa podacima saradnika {<br />}prazna
                  podrazumeva da izdajemo artikle{<br />} sopstvenom preduzeću</b>
              </div>
            </div>
          )}
          <button className={classes.iconButton} type="submit" onClick={doReservation}>
            <IoIosSave />
          </button>
          <button className={classes.iconButton} type="submit" onClick={doOutput}>
            <FontAwesomeIcon
              icon={faLongArrowAltDown}
              className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};

export default NewStockOutputToProjectOrPartnerPopover;
